import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useDeleteWidgetMutation } from "./__generated__/useDeleteWidgetMutation.graphql";

export const useDeleteWidget = (storecastId: string) => {
  const [mutate] = useMutation<useDeleteWidgetMutation>(graphql`
    mutation useDeleteWidgetMutation($storecastId: ID!, $widgetId: ID!) {
      dashboard(dashboardId: $storecastId) {
        deleteWidget(id: $widgetId) {
          id
          widgets {
            id
          }
        }
      }
    }
  `);
  const deleteWidget = useCallback(
    (widgetId: string) =>
      mutate({
        variables: { storecastId, widgetId },
        optimisticUpdater: (store) => {
          const storecast = store.get(storecastId);
          if (!storecast) return;
          storecast.setLinkedRecords(
            storecast
              .getLinkedRecords("widgets")
              ?.filter((w) => w.getDataID() !== widgetId) ?? [],
            "widgets"
          );
        },
      }),
    [mutate, storecastId]
  );
  return deleteWidget;
};
